import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgChevronDoubleBigRight = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M2.307 2.713A.75.75 0 0 1 3 2.25h9a.75.75 0 0 1 .53.22l9 9a.75.75 0 0 1 0 1.06l-9 9a.75.75 0 0 1-.53.22H3a.75.75 0 0 1-.53-1.28L10.94 12 2.47 3.53a.75.75 0 0 1-.163-.817M4.811 3.75l7.72 7.72a.75.75 0 0 1 0 1.06l-7.72 7.72h6.878L19.94 12l-8.25-8.25z"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgChevronDoubleBigRight;
